const topicData = [
  { label: '娱乐圈塌房', count: '1.2万条', hot: true },
  { label: '网红翻车', count: '9.8千条', hot: true },
  { label: '明星恋情', count: '8.5千条', hot: true },
  { label: '综艺内幕', count: '7.2千条', hot: false },
  { label: '带货造假', count: '6.6千条', hot: true },
  { label: '影视剧争议', count: '5.9千条', hot: false },
  { label: '品牌代言瓜', count: '5.1千条', hot: false },
  { label: '饭圈互撕', count: '4.8千条', hot: true },
  { label: '直播事故', count: '4.3千条', hot: false },
  { label: '商界八卦', count: '3.7千条', hot: false },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            全网吃瓜群众都在讨论的热点标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicData.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              {item.hot && <i className="ri-fire-fill text-primary-500 text-xs"></i>}
              {item.label}
              <span className={`text-xs ${item.hot ? 'text-primary-500' : 'text-foreground-500'}`}>
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}